"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.titleProps = void 0;
/* istanbul ignore file @preserve */

const titleProps = exports.titleProps = {
  title: 'Categories'
};
